// Purpose: Exposes context-free BayHive color ramps and Lara-compatible primitive aliases.
import Lara from '@primeuix/themes/lara';
import {
  bayhiveBlue,
  bayhiveDanger,
  bayhiveGold,
  bayhiveInfo,
  bayhiveNeutral,
  bayhivePurple,
  bayhiveSuccess,
  bayhiveViolet,
  bayhiveWarn,
} from './shared.js';

export const bayhivePrimitives = {
  bayhive: {
    // Keep the physical-stock heading in the green family.
    availability: {
      green: Lara.primitive.green,
    },
    purple: bayhivePurple,
    violet: bayhiveViolet,
    gold: bayhiveGold,
    warn: bayhiveWarn,
    neutral: bayhiveNeutral,
    success: bayhiveSuccess,
    danger: bayhiveDanger,
    info: bayhiveInfo,
  },
  purple: bayhivePurple,
  green: bayhiveSuccess,
  red: bayhiveDanger,
  yellow: bayhiveWarn,
  orange: bayhiveWarn,
  amber: bayhiveWarn,
  sky: bayhiveBlue,
  blue: bayhiveBlue,
};

export default bayhivePrimitives;
